module.exports = __webpack_public_path__ + "static/media/ling_chen_chou.868ee951.jpg";